import {KoAPI} from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const InboxAPI = {
  rejectTimesheet(data, query, workspace){
    return KoAPI.update(`/api/${version}/home/inbox/worklog/changeRequest`, {query: { ...query }, data, header: { "workspace": workspace } });
  },
  getAllWorkLogsTime(id, query, workspaceId){
    return KoAPI.get(`/api/${version}/home/inbox/worklog/${id}`, { query: { ...query }, header: {
      "workspace": workspaceId
    } });
  },
  getIntervals(userId, workspaceId, query){
    return KoAPI.get(`/api/${version}/home/inbox/intervals/${userId}`, {query: { ...query }, header: {
      "workspace": workspaceId
    } });
  },
  approveTimesheet(query, data, workspace){
    return KoAPI.update(`/api/${version}/home/inbox/worklog/approved`, {query: { ...query }, data, header: { "workspace": workspace } });
  },
  getTimesheetApprovals(id, q, workspace){
    return KoAPI.get(`/api/${version}/home/inbox/week/worklog/waiting/${id}`,{ query: { ...q } , header: {
      "workspace": workspace
    } });
  },
  sendApprovalRequest(data, query, workspace){
    return KoAPI.update(`/api/${version}/home/inbox/worklog/approval/reassign`, { query: { ...query }, data, header: { "workspace": workspace } });
  },
  getWorkspaceData(q, id, workspace) {
    return KoAPI.get(`/api/${version}/home/inbox/approver/workspace/${id}`, { query: { ...q } , header: {
      "workspace": workspace
    } });
  },
  getTimesheetHistoryApproved(id, q, workspace){
    return KoAPI.get(`/api/${version}/home/inbox/worklog/approved/${id}`, { query: { ...q }, header: {
      "workspace": workspace
    } });
  },

  getTimesheetHistoryRejected(id,q, workspace){
    return KoAPI.get(`/api/${version}/home/inbox/worklog/rejected/${id}`, { query: { ...q } , header: {
      "workspace": workspace
    } });
  },
  getUsersbyTimeSheetId(query){
    return KoAPI.get(`/api/${version}/home/inbox/worklog/requested/users`, { query: { ...query } });
  },
  getAllTimesheets(id){
    return KoAPI.get(`/api/${version}/home/inbox/user/worklog/${id}`);
  },
  getTimesheetCount(id){
    return KoAPI.get(`/api/${version}/home/inbox/user/worklog/count/${id}`);
  },
  getAllWorkspace(id, query) {
    return KoAPI.get(`/api/${version}/home/inbox/approver/all/workspace/${id}`, { query: { ...query } });
  },
  getUserTotalHours(query) {
    return KoAPI.get(`/api/${version}/home/inbox/dashboard/total/hours`, { query: { ...query } });
  },
  getWeekTotalHours(id, query) {
    return KoAPI.get(`/api/${version}/home/inbox/dashboard/week/totalhours/${id}`, { query: { ...query } });
  },
  getUsersLeaveRequest(){
    return KoAPI.get(`/api/${version}/admin/leave/requested/users`);
  },
  getLeaveRequests(id, query){
    return KoAPI.get(`/api/${version}/inbox/leave/user/requests/${id}`, { query: { ...query } });
  },
  getWaitingLeaves(){
    return KoAPI.get(`/api/${version}/inbox/leave/requests/waiting`);
  },
  sendLeaveRequest(data){
    return KoAPI.update(`/api/${version}/inbox/leave/requests/approve`, { data });
  },
  rejectLeaveRequest(data){
    return KoAPI.update(`/api/${version}/inbox/leave/requests/reject`, { data });
  },

//  Expenses API

  createExpense(data, id){
    if(id){
      return KoAPI.update(`/api/${version}/admin/expense/request/${id}`,{data});
    }else{
      return KoAPI.post(`/api/${version}/admin/expense/create`,{data});
    }
  },

  getWorkspaceList() {
    return KoAPI.get(`/api/${version}/workspace`);
  },

  getCategoryList(){
    return KoAPI.get(`/api/${version}/admin/expense/category/all`);
  },

  getAllExpense(){
    return KoAPI.get(`/api/${version}/admin/expense/all`);
  },
  deleteExpense(id){
    return KoAPI.delete(`/api/${version}/admin/expense/request/${id}`);
  },
  getWaitingExpense(){
    return KoAPI.get(`/api/${version}/inbox/expense/requests/waiting`);
  },
  getUsersExpenseRequest(){
    return KoAPI.get(`/api/${version}/inbox/expense/requested/users`);
  },
  sendExpenseRequest(data){
    return KoAPI.update(`/api/${version}/inbox/expense/requests/approve`, { data });
  },
  rejectExpenseRequest(data){
    return KoAPI.update(`/api/${version}/inbox/expense/requests/reject`, { data });
  }
  


};